import QuestionGroupedInterface from '@interfaces/questions.interface'

export const getQuestions = [
  {
    group_id: '59db5a10-b15c-4922-8b7e-ad8b0f99ce40',
    labels: {
      label_id: '27ce347a-736a-4e57-bdcc-35fd3c6e7258',
      pt: 'Comportamento',
      en: 'Behavior',
      es: 'Comportamiento',
    },
    questions: [
      {
        question_id: '2881c1a5-d3ce-445c-9fbf-2180c806a902',
        labels: {
          label_id: 'decb9bef-b0cb-4bcf-a4fb-a6c5bee8e3e0',
          pt: 'Quais são as redes sociais que você mais utiliza?',
          en: 'What are the social networks that you use the most?',
          es: '¿Cuáles son las redes sociales que más utiliza?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: 'a68f2e90-8410-469a-8f89-008dfbde1c4e',
            labels: {
              label_id: '166aca5e-3903-4ac5-89a1-d08d7c32b163',
              pt: 'Facebook',
              en: 'Facebook',
              es: 'Facebook',
            },
          },
          {
            option_id: 'b708485f-c0d8-4c93-ad64-25cabd70f51d',
            labels: {
              label_id: 'cba4a925-53f4-4d01-b772-e7004801d969',
              pt: 'Snapchat',
              en: 'Snapchat',
              es: 'Snapchat',
            },
          },
          {
            option_id: '25c769f2-433f-4121-ad78-4e1206a79ed4',
            labels: {
              label_id: '1bb29627-f87c-49f7-b4ad-7409f161e5e4',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
          {
            option_id: 'f4717c8c-7f6c-4f90-8750-c63cf2271a07',
            labels: {
              label_id: 'ee328cae-a9a3-4f93-8019-8f6d3337edbb',
              pt: 'Youtube',
              en: 'Youtube',
              es: 'Youtube',
            },
          },
          {
            option_id: '680b89e8-94ed-47ab-b409-36a2e5459d92',
            labels: {
              label_id: 'cdbf99af-212b-43bd-aa7b-3c1685f931cb',
              pt: 'Twitch',
              en: 'Twitch',
              es: 'Twitch',
            },
          },
          {
            option_id: '903afc92-0668-4ce5-b3b9-c4f47bd5191e',
            labels: {
              label_id: '6d9c2c3d-05e6-40f7-9ef3-aabff2ab385d',
              pt: 'Instagram',
              en: 'Instagram',
              es: 'Instagram',
            },
          },
          {
            option_id: 'b512b0d3-4758-440e-bb68-3bafd5676d7e',
            labels: {
              label_id: '34c908a4-cc41-434d-9176-51a48640a6f6',
              pt: 'LinkedIn',
              en: 'LinkedIn',
              es: 'LinkedIn',
            },
          },
          {
            option_id: '182bfbde-6f1e-49d4-a145-07266ad09694',
            labels: {
              label_id: '65177b3d-6d99-4893-8c63-a4c1f1cfdff9',
              pt: 'Twitter',
              en: 'Twitter',
              es: 'Twitter',
            },
          },
          {
            option_id: 'c93b8234-7a4d-4853-bbaf-468e7e23f9c2',
            labels: {
              label_id: '7d6244c5-cde5-42c6-8192-2d117a1062ac',
              pt: 'TikTok',
              en: 'TikTok',
              es: 'TikTok',
            },
          },
          {
            option_id: '67ccc4c9-ae4d-4263-9a41-9e312661bb8c',
            labels: {
              label_id: '9be409ae-ec6b-49fd-96d0-13ae1046cf81',
              pt: 'Whatsapp',
              en: 'Whatsapp',
              es: 'Whatsapp',
            },
          },
          {
            option_id: '831e8c52-a4b5-4ace-8ff9-2a0a1ae8ac7c',
            labels: {
              label_id: '021a773b-3846-4a82-a28c-7db103755d8d',
              pt: 'Pinterest',
              en: 'Pinterest',
              es: 'Pinterest',
            },
          },
        ],
        required: 1,
        order: 1,
        active: 1,
      },
      {
        question_id: 'fd847b11-2ddd-45f8-a77e-50f8301aaa7a',
        labels: {
          label_id: '8f06300c-fcc2-43c1-afd7-e367b0553836',
          pt: 'Qual a sua rede social principal?',
          en: 'What is your main social network?',
          es: '¿Cuál es tu principal red social?',
        },
        type: 'select',
        options: [
          {
            option_id: 'b90ee5ee-ba39-41a6-b8b9-c4cb07486b20',
            labels: {
              label_id: 'ce25d42a-f64c-4b45-8e42-9226f7155e13',
              pt: 'Twitter',
              en: 'Twitter',
              es: 'Twitter',
            },
          },
          {
            option_id: '1338a492-3d6c-4b15-ab14-69f4fa0815f2',
            labels: {
              label_id: 'b60302bc-9f33-4679-a677-dc4fbc0da3b8',
              pt: 'Snapchat',
              en: 'Snapchat',
              es: 'Snapchat',
            },
          },
          {
            option_id: 'e6dc2583-785a-46a2-97d2-90f153e06dbe',
            labels: {
              label_id: '3e86019d-fdfe-4024-a81c-768a7de9746a',
              pt: 'LinkedIn',
              en: 'LinkedIn',
              es: 'LinkedIn',
            },
          },
          {
            option_id: '716c2cd8-25f5-49e3-8541-9d1185f97453',
            labels: {
              label_id: '7173f249-b2da-4028-914d-6b2718b49fed',
              pt: 'Whatsapp',
              en: 'Whatsapp',
              es: 'Whatsapp',
            },
          },
          {
            option_id: '83dfac90-58fd-4826-bcf6-9adcfc42be4d',
            labels: {
              label_id: '7328037b-ff65-4fd2-8d57-6f104401109c',
              pt: 'Twitch',
              en: 'Twitch',
              es: 'Twitch',
            },
          },
          {
            option_id: '856999fe-b5dc-4d29-9003-83f93ada408e',
            labels: {
              label_id: '4407f60f-af81-4b72-bead-e5d962390f21',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
          {
            option_id: 'e1418b48-6b34-423e-90ec-9e1af186c4bc',
            labels: {
              label_id: '963948c4-1668-4f1d-81e1-2a81770dceb4',
              pt: 'TikTok',
              en: 'TikTok',
              es: 'TikTok',
            },
          },
          {
            option_id: '2fad0aca-1c7b-4151-b2d6-cd0bd70a1710',
            labels: {
              label_id: 'ee2b9b11-c840-4d75-8ba7-2d8b076a5f32',
              pt: 'Facebook',
              en: 'Facebook',
              es: 'Facebook',
            },
          },
          {
            option_id: 'e8eb9c82-b9d4-4967-9325-476a2ec43074',
            labels: {
              label_id: 'fde146ea-1f89-4d26-bd68-3d1f90878c7d',
              pt: 'Youtube',
              en: 'Youtube',
              es: 'Youtube',
            },
          },
          {
            option_id: '8179f659-9180-44bd-b963-3122ed8648b7',
            labels: {
              label_id: '2b8fbd9f-3122-4d04-9df7-a17f373b231a',
              pt: 'Instagram',
              en: 'Instagram',
              es: 'Instagram',
            },
          },
          {
            option_id: '84064549-9ae6-4d90-a0a4-b8cdebccc7f4',
            labels: {
              label_id: '013e294c-63e7-4204-a6a6-e7c7eff0d9ad',
              pt: 'Pinterest',
              en: 'Pinterest',
              es: 'Pinterest',
            },
          },
        ],
        required: 1,
        order: 2,
        active: 1,
      },
      {
        question_id: '58cd48a4-3f78-4502-9f0a-2db7844e50c2',
        labels: {
          label_id: '658ad0a7-5b0c-4862-a297-8c74d91a51a4',
          pt: 'Baseado na questão anterior, com qual frequência você faz publicações na(s) rede(s) selecionada(s)?',
          en: 'Based on the previous question, how often do you post on the selected network(s)?',
          es: 'Basado en la pregunta anterior, ¿con qué frecuencia publica en la(s) red(es) seleccionada(s)?',
        },
        type: 'select',
        options: [
          {
            option_id: '0fe19809-b3ab-49f2-a51f-d80ef0a09fd0',
            labels: {
              label_id: 'd5905a56-84d4-4dfb-adec-fcf1750c2407',
              pt: 'Pelo menos uma vez ao dia',
              en: 'At least once a day',
              es: 'Al menos una vez al día',
            },
          },
          {
            option_id: '2b34c218-35a8-4b4a-8d0c-092cd94a290d',
            labels: {
              label_id: 'a48013b4-1b6d-4043-ab37-8c45b52a5329',
              pt: 'Mais de 5 vezes por semana',
              en: 'More than 5 times a week',
              es: 'Más de 5 veces por semana',
            },
          },
          {
            option_id: 'e7be91ea-b939-4d36-9add-53fb0e8e7b16',
            labels: {
              label_id: '92dc197b-a707-48e6-9fc7-08d461b5fc7c',
              pt: 'De 1 a 2 vezes por semana',
              en: 'From 1 to 2 times a week',
              es: 'De 1 a 2 veces por semana',
            },
          },
          {
            option_id: '18cbdf25-2990-4cad-b167-2855cc626368',
            labels: {
              label_id: '2b15a5db-9b19-4b6e-800f-de7a9b8c16c2',
              pt: 'De 3 a 4 vezes por semana',
              en: 'From 3 to 4 times a week',
              es: 'De 3 a 4 veces por semana',
            },
          },
          {
            option_id: '7141c0f1-83a5-410b-ae27-fd84292ca40a',
            labels: {
              label_id: '67a9ba7b-96cf-4395-a5b4-cd30ecc5b462',
              pt: 'Raramente faço publicações',
              en: 'I rarely make posts',
              es: 'Raramente hago publicaciones',
            },
          },
        ],
        required: 1,
        order: 3,
        active: 1,
      },
      {
        question_id: 'b92dee91-f008-477e-9466-a4bcc0c3f3b6',
        labels: {
          label_id: '3913028f-cf04-4fe2-9b55-e32dea1562b1',
          pt: 'Selecione as categorias de produtos você gostaria de receber para experimentar',
          en: 'Select the product categories you would like to receive to try',
          es: 'Seleccione las categorías de productos que le gustaría recibir para probar',
        },
        type: 'checkbox',
        options: [
          {
            option_id: 'cae7dbb4-7c1b-403f-a59a-774e3677c468',
            labels: {
              label_id: '45bca423-8a44-4164-a1b7-b48737d9cf81',
              pt: 'Produtos Infantis',
              // eslint-disable-next-line
              en: "Children's products",
              es: 'Productos infantiles',
            },
          },
          {
            option_id: '100875fb-5902-484d-8cc8-97d131b56c27',
            labels: {
              label_id: '656178a6-6bb6-4673-a4e2-570ee89184ba',
              pt: 'Vestuário',
              en: 'Clothing',
              es: 'Ropa',
            },
          },
          {
            option_id: '58fddcf3-3008-46c4-ad8f-a86c3176f29f',
            labels: {
              label_id: 'c73549ab-e6f3-426c-8448-e1bf000b5743',
              pt: 'Produtos para pets',
              en: 'Pet products',
              es: 'Productos para mascotas',
            },
          },
          {
            option_id: '9ef50fc9-8680-4c59-aa6f-077fab9553cf',
            labels: {
              label_id: '4f20e275-237d-4246-8b98-765ff9bc74ae',
              pt: 'Outro',
              en: 'Other',
              es: 'Otro',
            },
          },
          {
            option_id: 'c13e8170-70e4-4c0d-88ee-0f996ab7b5b7',
            labels: {
              label_id: 'd14bba5e-64e1-42aa-8365-521651524f94',
              pt: 'Cuidados com a pele',
              en: 'Skin care',
              es: 'Cuidado de la piel',
            },
          },
          {
            option_id: 'd0f5bb8d-c406-4e3f-bb8c-2e328f13644d',
            labels: {
              label_id: 'f001d427-3964-4320-8184-31840d9a2367',
              pt: 'Cuidados com o cabelo',
              en: 'Hair care',
              es: 'Cuidado del cabello',
            },
          },
          {
            option_id: '201d41db-492e-4ff5-9e98-8e36751368e3',
            labels: {
              label_id: 'ac8c16d3-45f0-4947-a0a6-2ecc765f2c73',
              pt: 'Games',
              en: 'Games',
              es: 'Juegos',
            },
          },
          {
            option_id: '68cbf5dc-ea37-47c6-a259-e7cd862b2258',
            labels: {
              label_id: 'ce86d01f-7a0f-4096-8ea5-8b3fdc7be3e3',
              pt: 'Eletrônicos',
              en: 'Electronics',
              es: 'Electrónicos',
            },
          },
          {
            option_id: 'a94df92f-b89e-4b65-89c3-241805079a89',
            labels: {
              label_id: 'f63b3c14-0b58-4c3a-8a83-365b3d7178cc',
              pt: 'Alimentos e bebidas',
              en: 'Food and beverages',
              es: 'Alimentos y bebidas',
            },
          },
        ],
        required: 1,
        order: 4,
        active: 1,
      },
      {
        question_id: '17ba747f-fa51-4c65-8668-fda4e90b2ada',
        labels: {
          label_id: '6dc88cac-33ad-4081-bb07-332198a150c5',
          pt: 'Qual seu estilo de alimentação?',
          en: 'What is your eating style?',
          es: '¿Cuál es tu estilo de alimentación?',
        },
        type: 'select',
        options: [
          {
            option_id: '071c5c04-d34b-404d-9f98-be0e5a48dd20',
            labels: {
              label_id: '82148ccc-9119-4796-8102-3c14200bd3ca',
              pt: 'Dieta baixa em carboidratos',
              en: 'Low carb diet',
              es: 'Dieta baja en carbohidratos',
            },
          },
          {
            option_id: 'b8429683-a333-49ca-8bb0-63b2c0cbe925',
            labels: {
              label_id: '10ed85eb-6bfa-4425-a981-5c3e12b6ecbc',
              pt: 'Vegano',
              en: 'Vegan',
              es: 'Vegano',
            },
          },
          {
            option_id: '4994e508-b684-42d8-aedc-af7d509629b5',
            labels: {
              label_id: '03ec9557-bdce-40d1-aed7-44b0e33aba57',
              pt: 'Vegetariano',
              en: 'Vegetarian',
              es: 'Vegetariano',
            },
          },
          {
            option_id: 'a727c4de-899b-4045-9100-41363a6892d8',
            labels: {
              label_id: '18001e0c-1051-47cc-8096-0c98545218fc',
              pt: 'Não tenho restrição',
              en: 'I have no restriction',
              es: 'No tengo restriccion',
            },
          },
          {
            option_id: 'b50a4f43-13ff-47f9-956c-de895d4feb09',
            labels: {
              label_id: 'a5e47ffd-bc12-491b-969a-62f73937fa9c',
              pt: 'Paleo',
              en: 'Paleo',
              es: 'Paleo',
            },
          },
          {
            option_id: '3298f3ea-8199-4eec-b085-f485059912c3',
            labels: {
              label_id: '7cb137e8-dc2f-4331-9139-b68363da9b38',
              pt: 'Flexitariano',
              en: 'Flexitarian',
              es: 'Flexitariano',
            },
          },
          {
            option_id: '63eb7748-ede2-4049-89b3-66a18d4fc6af',
            labels: {
              label_id: 'd73beacf-4b55-437e-9e5d-0801ebe1ba12',
              pt: 'Pescetariano',
              en: 'Pescetarian',
              es: 'Pescetariano',
            },
          },
          {
            option_id: 'a792715b-1dca-4a1e-a837-f1ae725daf2f',
            labels: {
              label_id: 'c42710eb-7be8-49b5-8ada-45f1f2b7b849',
              pt: 'Crudívoro',
              en: 'Raw foodist',
              es: 'Crudívoro',
            },
          },
        ],
        required: 1,
        order: 5,
        active: 1,
      },
      {
        question_id: '91ea16ec-1957-403f-9f11-6fc03077f1fd',
        labels: {
          label_id: '59d5083a-1230-4589-9957-e9e4abc83031',
          pt: 'Você se interessa ou se identifica com alguma causa social?',
          en: 'Are you interested or identify with any social cause?',
          es: '¿Te interesa o te identificas con alguna causa social?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '9530b6d5-5924-42b4-8bb4-e69989bd0a25',
            labels: {
              label_id: 'b92f6c3d-361e-45a7-bc6a-d8ce520800d7',
              pt: 'Empoderamento feminino',
              en: 'Feminine empowerment',
              es: 'Empoderamiento femenino',
            },
          },
          {
            option_id: '464f7816-d8d2-4dde-a095-2ca3ff9586c2',
            labels: {
              label_id: '170b046c-432e-43ab-9a60-8fced58869ac',
              pt: 'Combate ao abuso infantil e apoio às vítimas',
              en: 'Combat child abuse and support victims',
              es: 'Combate al abuso infantil y apoyo a las víctimas',
            },
          },
          {
            option_id: 'c7a8b96a-bdea-4b1e-80f4-9531acff6637',
            labels: {
              label_id: 'edf19c85-1160-49e1-a8a2-e34736917b73',
              pt: 'Defesa dos direitos indígenas',
              en: 'Defense of indigenous rights',
              es: 'Defensa de los derechos indígenas',
            },
          },
          {
            option_id: '4a0a0502-501b-431e-b7bd-6cc4cc4bd399',
            labels: {
              label_id: 'c24956bb-44b6-4dfc-9588-2cb39eaff8f8',
              pt: 'Combate à desigualdade racial',
              en: 'Combat racial inequality',
              es: 'Combate a la desigualdad racial',
            },
          },
          {
            option_id: 'e1e073a9-6940-4198-8698-1a81957bca83',
            labels: {
              label_id: 'e20322d9-180b-4bbb-9e37-7fd57b4243c0',
              pt: 'Apoio a mulheres vítimas de violência',
              en: 'Support for women victims of violence',
              es: 'Apoyo a mujeres víctimas de violencia',
            },
          },
          {
            option_id: '5382a6ed-f668-43db-8d48-5a063a336590',
            labels: {
              label_id: 'd133615a-2ae2-4449-907c-0ee6a9b868d9',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
          {
            option_id: 'f1f620b8-5ac3-420e-b970-d0180170ba52',
            labels: {
              label_id: '424cd755-d930-4d16-abeb-b6b0e7dbf227',
              pt: 'Apoio a pessoas em situação de rua',
              en: 'Support for people in street situations',
              es: 'Apoyo a personas en situación de calle',
            },
          },
          {
            option_id: '1eb0ad2a-46f9-4846-8af0-6480a25d6b11',
            labels: {
              label_id: 'de81902d-1eff-47c5-a30f-8ac0c5ba54c9',
              pt: 'Apoio a dependentes químicos',
              en: 'Support for drug addicts',
              es: 'Apoyo a adictos a las drogas',
            },
          },
          {
            option_id: '8992f694-9907-4568-8619-83f6970f05b6',
            labels: {
              label_id: 'ed65510f-f8ed-42f9-9f5c-dcb55532e4f9',
              pt: 'Preservação do meio ambiente',
              en: 'Preservation of the environment',
              es: 'Preservación del medio ambiente',
            },
          },
          {
            option_id: 'bb2894fc-c91e-49b2-b688-219d710769a4',
            labels: {
              label_id: 'da957d1a-2025-4876-9d99-94d579577f62',
              pt: 'Crianças desaparecidas',
              en: 'Missing children',
              es: 'Niños desaparecidos',
            },
          },
          {
            option_id: '47aea8a5-24b0-4471-b35c-78cdbd878fab',
            labels: {
              label_id: '13f1a708-6813-4bb9-a347-df8ed7dff4b2',
              pt: 'Acolhimento e melhora da qualidade de vida de idosos',
              en: 'Reception and improvement of the quality of life of the elderly',
              es: 'Recepción y mejora de la calidad de vida de los ancianos',
            },
          },
          {
            option_id: 'd5a873bd-464b-499c-97de-b1c672ba3ee9',
            labels: {
              label_id: '818d45f8-c842-4cd3-9b5a-5e5229b93d0c',
              pt: 'Inclusão de refugiados',
              en: 'Refugee inclusion',
              es: 'Inclusión de refugiados',
            },
          },
          {
            option_id: '5280d283-3619-43f6-8b22-3bf1d53fd85d',
            labels: {
              label_id: '5ee9a8e7-b246-4dfa-8e56-b09430d59f13',
              pt: 'Ajuda a animais abandonados',
              en: 'Help abandoned animals',
              es: 'Ayuda a animales abandonados',
            },
          },
          {
            option_id: 'e639bc37-59fd-43fc-9741-5cdd1e0e5595',
            labels: {
              label_id: '6d2ef5a2-840c-46e7-9f57-e95e7282307a',
              pt: 'Educação de crianças e jovens',
              en: 'Education of children and young people',
              es: 'Educación de niños y jóvenes',
            },
          },
          {
            option_id: '19eb1541-1368-42b9-9990-7dbb5a04db1f',
            labels: {
              label_id: 'fdd72b27-1c77-4491-ba3f-2e85c61f14b2',
              pt: 'Combate à pobreza',
              en: 'Combat poverty',
              es: 'Combate a la pobreza',
            },
          },
          {
            option_id: '5a681045-6969-4852-9f36-4dbbe034331e',
            labels: {
              label_id: '4e72fdd6-9240-48d1-b455-6fb519fd1db4',
              pt: 'Inclusão de pessoas com deficiência',
              en: 'Inclusion of people with disabilities',
              es: 'Inclusión de personas con discapacidad',
            },
          },
        ],
        required: 0,
        order: 6,
        active: 1,
      },
      {
        question_id: '34498292-b309-400e-83de-c15d149aa3d3',
        labels: {
          label_id: '791a0dfa-e4c3-4d9e-bef0-acf5d0bd62c9',
          pt: 'Quais bebidas alcoólicas você mais consome?',
          en: 'Which alcoholic beverages do you consume most often?',
          es: '¿Qué bebidas alcohólicas consumes con más frecuencia?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: 'e86075e3-1225-4422-b433-f5f034952520',
            labels: {
              label_id: '3bfd9eb6-63a3-40c2-9ee0-96a477fa86cb',
              pt: 'Cachaça',
              en: 'Cachaça',
              es: 'Cachaça',
            },
          },
          {
            option_id: '5861329e-6b5a-4d2e-b866-56aac1d2a710',
            labels: {
              label_id: '5edb7ce2-9d72-4858-b37b-634a58058d06',
              pt: 'Conhaque',
              en: 'Brandy',
              es: 'Coñac',
            },
          },
          {
            option_id: '7312dc21-f87c-4add-87c8-fd385eafa9c9',
            labels: {
              label_id: 'c606d337-d193-4300-8159-55b46fa5a1c4',
              pt: 'Tequila',
              en: 'Tequila',
              es: 'Tequila',
            },
          },
          {
            option_id: '93b5a054-0ce1-42ce-a588-e2fb056b19f1',
            labels: {
              label_id: 'a27b055c-4ce7-45f9-b5ab-bc7025479598',
              pt: 'Gin',
              en: 'Gin',
              es: 'Gin',
            },
          },
          {
            option_id: '3eb2e975-5367-46e9-a707-e2f8f1b4e5a0',
            labels: {
              label_id: '730be0af-3c0f-4b7c-89c1-f6e3779ed680',
              pt: 'Cerveja',
              en: 'Beer',
              es: 'Cerveza',
            },
          },
          {
            option_id: 'e3fdcfce-76e3-460a-a8ab-176df09432b0',
            labels: {
              label_id: '50dbdfe4-fe8f-4c7b-b7ea-51489f93a4b6',
              pt: 'Whisky',
              en: 'Whisky',
              es: 'Whisky',
            },
          },
          {
            option_id: 'eefa8fe6-321c-4c0e-8494-6cba9e62f47b',
            labels: {
              label_id: '3b7ea4b0-9ef9-439a-adc2-09c7e6779570',
              pt: 'Vodka',
              en: 'Vodka',
              es: 'Vodka',
            },
          },
          {
            option_id: '6aca74f5-0a90-4d78-967a-50b24706e5a2',
            labels: {
              label_id: '3197b0cd-ced9-4666-b973-e70253ef2823',
              pt: 'Caipirinha',
              en: 'Caipirinha',
              es: 'Caipirinha',
            },
          },
          {
            option_id: '8c860b5f-32e8-48eb-b0ed-6c77b8de48bb',
            labels: {
              label_id: '772904d3-09ee-42b3-abb6-340a209e46ec',
              pt: 'Saquê',
              en: 'Sake',
              es: 'Sake',
            },
          },
          {
            option_id: '3646f00e-2f51-44ee-a3aa-cd3de9a02f2f',
            labels: {
              label_id: '3f9bcd4f-eebb-48ca-a19a-10da5ee6af9f',
              pt: 'Vinho',
              en: 'Wine',
              es: 'Vino',
            },
          },
          {
            option_id: 'e0a6230f-eba8-4b69-8d87-e9b98598e689',
            labels: {
              label_id: '875cea95-650d-4d36-894e-379cdfad7e29',
              pt: 'Rum',
              en: 'Rum',
              es: 'Ron',
            },
          },
        ],
        required: 0,
        order: 7,
        active: 1,
      },
      {
        question_id: '4fe5779a-2473-4cd6-9119-6ada1aac464c',
        labels: {
          label_id: '104c60a1-33ad-4b74-96ae-9078e53ed6c2',
          pt: 'Você ouve músicas. Se sim, qual serviço você utiliza?',
          en: 'Do you listen to music? If so, which service do you use?',
          es: '¿Escuchas música? Si es así, ¿qué servicio utilizas?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '6940f593-ac7f-4cdc-9e09-fbc710c25cf4',
            labels: {
              label_id: '9b21cdde-f34e-4f06-bc56-8e88e6317512',
              pt: 'CDs',
              en: 'CDs',
              es: 'CDs',
            },
          },
          {
            option_id: '881aacce-df5a-48c0-ad11-51db1ea21e7d',
            labels: {
              label_id: 'ffbdd474-a09d-4332-b864-e2c6eb2dbf59',
              pt: 'Apple Music',
              en: 'Apple Music',
              es: 'Apple Music',
            },
          },
          {
            option_id: '2f9db420-ea3d-42a3-8e2d-2311c2590773',
            labels: {
              label_id: 'cf18eee9-9aab-4d3e-b0bd-37a29aadfce1',
              pt: 'Deezer',
              en: 'Deezer',
              es: 'Deezer',
            },
          },
          {
            option_id: 'a3b114a0-3e4a-45f9-aab4-70dc3bc2496d',
            labels: {
              label_id: 'cb0f7978-3dac-45b2-ba44-592f8cb0f8cb',
              pt: 'Discos de Vinil',
              en: 'Vinyl Records',
              es: 'Discos de Vinilo',
            },
          },
          {
            option_id: '57b3c677-a332-4457-af37-9aace53ffe34',
            labels: {
              label_id: 'a5b3da0a-9e51-4779-a398-a0e5d5f08213',
              pt: 'Spotify',
              en: 'Spotify',
              es: 'Spotify',
            },
          },
          {
            option_id: 'c65144fe-5b98-473c-a1fc-73332f5b3f19',
            labels: {
              label_id: 'eca33605-0c0b-44b9-89d0-4baed2ac688c',
              pt: 'Google Music',
              en: 'Google Music',
              es: 'Google Music',
            },
          },
          {
            option_id: '748829fe-fbc4-4a5b-be49-f270f2371ac2',
            labels: {
              label_id: '352089c8-e41e-4f64-ba0d-2aad4753526c',
              pt: 'Napster',
              en: 'Napster',
              es: 'Napster',
            },
          },
          {
            option_id: '99e6c0fb-c2aa-41d2-a981-797f950c7284',
            labels: {
              label_id: '3caea67e-3e53-4ee9-ab82-e61aa963bdde',
              pt: 'Rádio FM',
              en: 'FM Radio',
              es: 'Rádio FM',
            },
          },
          {
            option_id: '534cd3ac-3602-40a2-8de0-fe7267c4c14f',
            labels: {
              label_id: '1458f51b-4b01-44ae-9ad9-ab147dbbdc85',
              pt: 'Arquivos digitais (Mp3)',
              en: 'Digital files (Mp3)',
              es: 'Archivos digitales (Mp3)',
            },
          },
          {
            option_id: 'aaeff646-cf93-4907-a023-6a043788972c',
            labels: {
              label_id: '06b6e4bd-8dfc-481a-a004-f919330cce2e',
              pt: 'Youtube',
              en: 'Youtube',
              es: 'Youtube',
            },
          },
        ],
        required: 0,
        order: 8,
        active: 1,
      },
      {
        question_id: '3bdffc80-39db-4fc9-bd16-25beef9aafa0',
        labels: {
          label_id: 'bee95862-75d2-4411-8b40-426693443c85',
          pt: 'Assinale qual(is) esporte/atividade física você pratica mais de 1x na semana',
          en: 'Check which sport / physical activity you practice more than 1x a week',
          es: 'Marque qué deporte / actividad física practicas más de 1x a la semana',
        },
        type: 'checkbox',
        options: [
          {
            option_id: 'b5034765-2238-4799-a25d-301a34d3142b',
            labels: {
              label_id: '08e01c3d-58c0-466d-8993-0b7036e48eb8',
              pt: 'Caminhada',
              en: 'Walking',
              es: 'Caminando',
            },
          },
          {
            option_id: '3ef8a4ee-210a-49dc-9020-3dbe381e5337',
            labels: {
              label_id: '970b5701-de2a-4c50-9429-b722ec3a671d',
              pt: 'Crossfit',
              en: 'Crossfit',
              es: 'Crossfit',
            },
          },
          {
            option_id: '00ff2e30-1b2a-4f81-8a2e-8fc94b7202ce',
            labels: {
              label_id: 'bf8eb3e2-f93a-480f-91fb-6bf1b3bc1e5b',
              pt: 'Corrida',
              en: 'Running',
              es: 'Corriendo',
            },
          },
          {
            option_id: 'ee0ebffd-fd7f-4563-be29-b51354434812',
            labels: {
              label_id: 'dcba56c6-52a7-419b-9af0-978ecafba280',
              pt: 'Basquete',
              en: 'Basketball',
              es: 'Baloncesto',
            },
          },
          {
            option_id: '786f5537-4b47-46ad-9beb-abf518415a87',
            labels: {
              label_id: '3c17c4ff-04b2-4666-9d8a-3df7da531d88',
              pt: 'Dança',
              en: 'Dance',
              es: 'Danza',
            },
          },
          {
            option_id: '19c18b64-5e92-49a8-bd0c-ce0a7015bdba',
            labels: {
              label_id: '40743d86-8731-4a40-9d66-281fda681985',
              pt: 'Yoga',
              en: 'Yoga',
              es: 'Yoga',
            },
          },
          {
            option_id: '7d572471-6b6a-4439-9193-dfc2ef3c43fe',
            labels: {
              label_id: '2d86de35-32cc-4ee7-9d0a-22d51483556a',
              pt: 'Artes marciais',
              en: 'Martial arts',
              es: 'Artes marciales',
            },
          },
          {
            option_id: '377d9d37-5807-4c04-9925-f3f31a5f70cc',
            labels: {
              label_id: 'b2fcd919-dd77-413c-b394-bdd11418a6de',
              pt: 'Musculação',
              en: 'Bodybuilding',
              es: 'Culturismo',
            },
          },
          {
            option_id: 'aab2153d-9be0-45d1-a4ed-8d3ce6a0058e',
            labels: {
              label_id: '167c3ded-d270-4a39-a47f-90415b5c5914',
              pt: 'Natação',
              en: 'Swimming',
              es: 'Natación',
            },
          },
          {
            option_id: 'e6e78558-6ca8-4a55-a18e-b47fbbb14d99',
            labels: {
              label_id: '3885a49c-df21-4b7f-baf5-c06419863249',
              pt: 'Futebol',
              en: 'Soccer',
              es: 'Fútbol',
            },
          },
          {
            option_id: '4695ce9c-c75e-4220-b9c2-b46c659d2d6d',
            labels: {
              label_id: 'd0c6dd04-ac7f-4aa0-9a22-760a049c8098',
              pt: 'Tênis',
              en: 'Tennis',
              es: 'Tenis',
            },
          },
          {
            option_id: '07ab40da-dcc1-40b3-af55-9ff31aa344d8',
            labels: {
              label_id: '182d80b9-7cc5-4dd1-8c0f-397a3360f07e',
              pt: 'Vôlei',
              en: 'Volleyball',
              es: 'Voleibol',
            },
          },
          {
            option_id: 'eeee59ce-af61-48e7-a3d3-34543525d114',
            labels: {
              label_id: 'd08e815d-65d5-4e92-b57b-5c3bf411b1e6',
              pt: 'Ciclismo',
              en: 'Cycling',
              es: 'Ciclismo',
            },
          },
          {
            option_id: '7a3bc6fa-0834-41f2-b067-5881daff1418',
            labels: {
              label_id: '5e9ed300-e4f5-4e31-83e4-29b8d5b46f21',
              pt: 'Pilates',
              en: 'Pilates',
              es: 'Pilates',
            },
          },
          {
            option_id: '2b7a7ac6-a765-4d48-8924-f9a4262dd5f6',
            labels: {
              label_id: '4164c33b-fd14-4e94-a738-defb3519f73a',
              pt: 'Outro',
              en: 'Other',
              es: 'Otro',
            },
          },
          {
            option_id: 'a07fba13-4212-4361-afec-d9e3f9cdbcdb',
            labels: {
              label_id: '6fdc75a0-4de3-4d22-a160-3eeda84e45ca',
              pt: 'Escalada',
              en: 'Climbing',
              es: 'Escalada',
            },
          },
        ],
        required: 0,
        order: 9,
        active: 1,
      },
      {
        question_id: 'd12803a8-42fc-413c-861f-e2221b707160',
        labels: {
          label_id: '4d49a4e2-8963-43d0-84fa-01e81ff53f26',
          pt: 'O que você costuma fazer nos momentos de lazer?',
          en: 'What do you usually do in your leisure time?',
          es: '¿Qué sueles hacer en tu tiempo libre?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '9decec70-60bd-46eb-b2eb-3303505af38b',
            labels: {
              label_id: 'c29cb694-f7b1-459f-945c-d090cc13e20d',
              pt: 'Ler livros, revistas ou jornais',
              en: 'Read books, magazines or newspapers',
              es: 'Leer libros, revistas o periódicos',
            },
          },
          {
            option_id: '4267f7aa-3d35-4687-b5df-998d52aeabb0',
            labels: {
              label_id: 'bb535ff0-b50c-47da-bf1b-e91eb1a58162',
              pt: 'Ir a eventos culturais, como teatro ou museus',
              en: 'Go to cultural events, such as theater or museums',
              es: 'Ir a eventos culturales, como teatro o museos',
            },
          },
          {
            option_id: 'a31e8570-79b3-4ed9-9985-ad28fa05d0c0',
            labels: {
              label_id: 'a8faa78d-db04-4f29-9643-27a648da5313',
              pt: 'Cozinhar',
              en: 'Cook',
              es: 'Cocinar',
            },
          },
          {
            option_id: '0b72f7b1-3b7a-4341-a8b9-f87445a77bae',
            labels: {
              label_id: 'f6bfddbc-710a-4cb9-b3c7-68a68e718326',
              pt: 'Ouvir música ou podcasts',
              en: 'Listen to music or podcasts',
              es: 'Escuchar música o podcasts',
            },
          },
          {
            option_id: '741a57e0-df02-4db8-861b-2737ce466cd3',
            labels: {
              label_id: '44f9f11b-48bb-4e1a-92db-df4ed912ea05',
              pt: 'Jogar videogames ou jogos de tabuleiro',
              en: 'Play video games or board games',
              es: 'Jugar videojuegos o juegos de mesa',
            },
          },
          {
            option_id: 'bf320438-03e5-47ce-94d6-78fe12376466',
            labels: {
              label_id: 'cbbb155e-3fa4-4b85-9836-e3d656738709',
              pt: 'Assistir Televisão (aberta e/ou por assinatura)',
              en: 'Watch TV (open and / or subscription)',
              es: 'Ver televisión (abierta y / o suscripción)',
            },
          },
          {
            option_id: '1883e987-c70e-41f5-8606-c18e762944e6',
            labels: {
              label_id: '016f4f2f-3cf6-4cb6-bb55-b0aa6227ddef',
              pt: 'Ir em Festivais',
              en: 'Go to Festivals',
              es: 'Ir a Festivales',
            },
          },
          {
            option_id: '82adb857-450f-4fd6-acfd-16391c12ba57',
            labels: {
              label_id: '2dba7191-2a13-436e-8b5f-25c45be18284',
              pt: 'Jogar jogos de carta ou tabuleiro',
              en: 'Play card or board games',
              es: 'Jugar juegos de cartas o de mesa',
            },
          },
          {
            option_id: 'ead04956-4a11-458e-8a2d-fda3b71da95a',
            labels: {
              label_id: 'f71b190e-4af1-44c3-9a9e-5939a5932a91',
              pt: 'Fazer trabalhos manuais, como artesanato/costura',
              en: 'Do manual work, such as crafts / sewing',
              es: 'Hacer trabajos manuales, como artesanía / costura',
            },
          },
          {
            option_id: '27c43f12-f3b9-49f3-a6c9-65cf65ef5102',
            labels: {
              label_id: '68ce16d8-ede5-403d-951d-0548392d895c',
              pt: 'Fazer voluntariado ou trabalhos comunitários',
              en: 'Volunteer or community work',
              es: 'Voluntariado o trabajo comunitario',
            },
          },
          {
            option_id: '9806773d-3baa-4fbf-8046-7cb18547d108',
            labels: {
              label_id: 'b27f1796-7894-482a-9a67-0bf4fcd6db81',
              pt: 'Ir ao Cinema',
              en: 'Go to the movies',
              es: 'Ir al cine',
            },
          },
          {
            option_id: '9f20fbc7-db97-4b6d-82e9-80651b152a46',
            labels: {
              label_id: 'b11b55d4-61ea-44c4-b525-9f594360716c',
              pt: 'Cuidar de animais de estimação',
              en: 'Take care of pets',
              es: 'Cuidar de mascotas',
            },
          },
          {
            option_id: '72dbbd65-8534-4810-8355-e71e09b1f07c',
            labels: {
              label_id: 'f9b9c0bf-225b-4f54-b3ce-4dbcbdf866db',
              pt: 'Assistir filmes e séries por streaming (Netflix, Amazon, Disney)',
              en: 'Watch movies and series by streaming (Netflix, Amazon, Disney)',
              es: 'Ver películas y series por streaming (Netflix, Amazon, Disney)',
            },
          },
          {
            option_id: 'bd3d89fc-5d9c-4ebe-a80f-d5b22c83de10',
            labels: {
              label_id: '79cb7be4-4cb8-46ea-bbe3-f1859682b554',
              pt: 'Viajar',
              en: 'Travel',
              es: 'Viajar',
            },
          },
          {
            option_id: '12787f18-79eb-4957-94d0-b3a3de3a8de3',
            labels: {
              label_id: 'c3ed8ffa-329c-472a-96a7-b885808851a8',
              pt: 'Meditar ou praticar ioga',
              en: 'Meditate or practice yoga',
              es: 'Meditar o practicar yoga',
            },
          },
          {
            option_id: '76034076-e63d-485e-aa59-ed615dcd8ef8',
            labels: {
              label_id: '2c5dbd44-1d6b-440d-be7e-f493f55855a0',
              pt: 'Praticar esportes ou atividades físicas',
              en: 'Practice sports or physical activities',
              es: 'Practicar deportes o actividades físicas',
            },
          },
          {
            option_id: 'cd0f6496-2a46-4c4e-93e0-3b0547b39128',
            labels: {
              label_id: '8d9087fa-f69d-435c-ae12-f23ab370824b',
              pt: 'Socializar com amigos e familiares',
              en: 'Socialize with friends and family',
              es: 'Socializar con amigos y familiares',
            },
          },
          {
            option_id: '205d856b-628a-4db7-8cfc-bff52017e3b2',
            labels: {
              label_id: '5c792a4f-4070-48e0-9c8e-ce88254dadd8',
              pt: 'Ir em Shows',
              en: 'Go to Shows',
              es: 'Ir a Shows',
            },
          },
          {
            option_id: '94de8bb6-28c2-48e4-ad18-dc4ac4a80b95',
            labels: {
              label_id: '8cf32095-c407-4bb9-a83b-d10110ccd9fc',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
        ],
        required: 1,
        order: 10,
        active: 1,
      },
      {
        question_id: '07f35611-e4ee-47e9-98c2-bf05b5008046',
        labels: {
          label_id: '77b3304f-7e82-4ee3-9b29-916dcc169dc1',
          pt: 'Qual sua orientação sexual?',
          en: 'What is your sexual orientation?',
          es: '¿Cuál es tu orientación sexual?',
        },
        type: 'select',
        options: [
          {
            option_id: '04a416ef-eeab-4848-a088-6287211fb561',
            labels: {
              label_id: '8544f4b4-b330-409b-a9e3-b2666e8d0332',
              pt: 'Outro',
              en: 'Other',
              es: 'Otro',
            },
          },
          {
            option_id: '36c4c27b-749a-4e86-bffb-f087426bf3a5',
            labels: {
              label_id: '006a8a20-8ab0-4270-89fa-4873a48b2e5c',
              pt: 'Heterossexual',
              en: 'Heterosexual',
              es: 'Heterosexual',
            },
          },
          {
            option_id: '856a7aa6-4613-4e32-8488-d3fa1e09c31f',
            labels: {
              label_id: 'faf471e5-1886-4883-af62-ea18e9887f3c',
              pt: 'Bissexual',
              en: 'Bisexual',
              es: 'Bisexual',
            },
          },
          {
            option_id: 'f71bc6e7-3037-4540-a1d1-9d498ebc6f51',
            labels: {
              label_id: '1f4ead07-3290-4ba1-847b-bb82e82c8402',
              pt: 'Assexual',
              en: 'Asexual',
              es: 'Asexual',
            },
          },
          {
            option_id: '327ccb95-9fd7-4e07-9db2-7f762b3dd2b8',
            labels: {
              label_id: 'e33c2521-1618-465c-b5b5-c73cd3810c46',
              pt: 'Não identificado',
              en: 'Unidentified',
              es: 'No identificado',
            },
          },
          {
            option_id: '6ca6b36e-5448-48e1-89b5-854c10b0f0d2',
            labels: {
              label_id: 'ab54ee65-32a5-4340-8c50-ef97ebb55cd6',
              pt: 'Homossexual',
              en: 'Homosexual',
              es: 'Homosexual',
            },
          },
          {
            option_id: 'ae111807-33fe-4936-a3da-5a1223d92091',
            labels: {
              label_id: 'f8aef2fb-a4d9-4fc1-b819-41afc02515aa',
              pt: 'Pansexual',
              en: 'Pansexual',
              es: 'Pansexual',
            },
          },
        ],
        required: 1,
        order: 11,
        active: 1,
      },
    ],
    icon: 'users-viewfinder',
    order: 2,
  },
  {
    group_id: 'a840940a-c2d9-4222-876d-59c588e5299e',
    labels: {
      label_id: 'f804bd18-85dd-4034-b3de-33f0c96b57c1',
      pt: 'Meu Perfil',
      en: 'My profile',
      es: 'Mi perfil',
    },
    questions: [
      {
        question_id: '4eb10e51-ff33-4700-8ce3-e0c4e49fd5fd',
        labels: {
          label_id: 'b2f3c126-9d5c-4314-a95e-75b7dfb775f0',
          pt: 'Qual é seu o nível de escolaridade?',
          en: 'What is your level of education?',
          es: '¿Cuál es su nivel de educación?',
        },
        type: 'select',
        options: [
          {
            option_id: 'fc84d323-f6dc-48fa-8a25-654b3a9612ee',
            labels: {
              label_id: '9cd8ef23-5b10-4e25-9638-7701a4c004b5',
              pt: 'Fundamental Completo',
              en: 'Complete Elementary',
              es: 'Escuela Primaria Completa',
            },
          },
          {
            option_id: '29264302-edf4-45f7-8181-bb9cfeb0bdf1',
            labels: {
              label_id: 'cf30e88e-4846-455b-8a74-fdc7248d3147',
              pt: 'Mestrado Completo',
              // eslint-disable-next-line
              en: "Complete Master's",
              es: 'Maestría Completo',
            },
          },
          {
            option_id: 'd18604d2-6ecd-4f6f-9eb2-efc9b4d6fb57',
            labels: {
              label_id: '9119ed2a-4d8f-4d9c-9ff1-8c99371a2e2b',
              pt: 'Superior Completo',
              en: 'Complete Higher Education',
              es: 'Superior Completo',
            },
          },
          {
            option_id: '0a5e5994-9751-4364-9f15-c197deb0882b',
            labels: {
              label_id: '483f9cab-99fd-4b53-ab0e-31c6703d27b1',
              pt: 'Pós-graduação Completo',
              en: 'Complete Postgraduate',
              es: 'Graduado Completo',
            },
          },
          {
            option_id: 'ebbe252f-83e1-4efe-9e81-deccdb94521e',
            labels: {
              label_id: '8578292f-3e92-4dac-95bc-24a344664294',
              pt: 'Fundamental Incompleto',
              en: 'Incomplete Elementary',
              es: 'Escuela Primaria Incompleta',
            },
          },
          {
            option_id: '245510ea-96ba-4dd7-952f-e1f796d861c2',
            labels: {
              label_id: '75c74795-e6ef-4efe-b500-9342b3ce8fac',
              pt: 'Médio Completo',
              en: 'Complete High School',
              es: 'Medio Completo',
            },
          },
          {
            option_id: 'fc1f30a7-8e83-406b-810a-3c0d86c7e189',
            labels: {
              label_id: 'a9f5d47f-8ac9-4bc9-911d-1a5352208c3c',
              pt: 'Pós-graduação Incompleto',
              en: 'Incomplete Postgraduate',
              es: 'Graduado Incompleto',
            },
          },
          {
            option_id: '6b7f5053-9991-4f51-bcde-7ced76f48a69',
            labels: {
              label_id: 'ee13c95d-ca05-425a-b94a-f94b562617ff',
              pt: 'Doutorado Incompleto',
              en: 'Incomplete Doctorate',
              es: 'Doctorado Incompleto',
            },
          },
          {
            option_id: '0662b8a2-193d-45ff-835c-dda514caf28e',
            labels: {
              label_id: '78a19828-d037-46c9-b5a3-290e4ace39e1',
              pt: 'Médio Incompleto',
              en: 'Incomplete High School',
              es: 'Medio incompleto',
            },
          },
          {
            option_id: 'e79971c8-4916-4062-9619-e3009a81d23a',
            labels: {
              label_id: '15b66e2f-82d3-43cb-8259-66c51d847a24',
              pt: 'Superior Incompleto',
              en: 'Incomplete Higher Education',
              es: 'Superior Incompleto',
            },
          },
          {
            option_id: '158aac4a-9c08-4ba1-8a5a-6757976c34fd',
            labels: {
              label_id: '40303e84-caa0-46c5-933c-4f8e1d62d91c',
              pt: 'Mestrado Incompleto',
              // eslint-disable-next-line
              en: "Incomplete Master's",
              es: 'Maestría Incompleto',
            },
          },
          {
            option_id: 'eded34c8-644b-4070-81ba-9ed90311a202',
            labels: {
              label_id: 'ef1c70bd-e4e6-4ceb-b8f7-037af5c3bdc1',
              pt: 'Doutorado Completo',
              en: 'Complete Doctorate',
              es: 'Doctorado Completo',
            },
          },
        ],
        required: 1,
        order: 1,
        active: 1,
      },
      {
        question_id: '82f4aefc-fd79-44ca-9127-848276599639',
        labels: {
          label_id: '3f7948ba-60bb-42ba-99fd-06f9cdb0e55b',
          pt: 'Em que área você atua profissionalmente?',
          en: 'In which area do you work professionally?',
          es: '¿En qué área te desempeñas profesionalmente?',
        },
        type: 'select',
        options: [
          {
            option_id: 'e645b2de-6f3b-4205-8674-f5b6569bf5ea',
            labels: {
              label_id: '336a5338-fcd6-431b-a8ea-86f49ea47573',
              pt: 'Recursos Humanos',
              en: 'Human Resources',
              es: 'Recursos Humanos',
            },
          },
          {
            option_id: '2b320ee6-2449-4934-a755-d7af177176c7',
            labels: {
              label_id: 'dbe7760d-70b0-4821-b971-f30d888247ba',
              pt: 'Jurídico',
              en: 'Legal',
              es: 'Jurídico',
            },
          },
          {
            option_id: '95ddc740-76bc-473d-ae61-3999d55fde28',
            labels: {
              label_id: '1959b7dd-f216-4b29-9996-756dd005bac5',
              pt: 'Marketing e Comunicação',
              en: 'Marketing and Communication',
              es: 'Marketing y Comunicación',
            },
          },
          {
            option_id: '41b76864-0b65-4e72-8e38-df6a7e83538c',
            labels: {
              label_id: 'f5db23d8-5a40-499b-9751-e02b7d313896',
              pt: 'Capacitação - Ensino – Educação',
              en: 'Training - Teaching - Education',
              es: 'Capacitación - Enseñanza - Educación',
            },
          },
          {
            option_id: 'ea495557-c9d0-49b9-815b-c23981133381',
            labels: {
              label_id: '95985c67-b75a-43df-a3b7-b79463929361',
              pt: 'Segurança e proteção',
              en: 'Security and protection',
              es: 'Seguridad y protección',
            },
          },
          {
            option_id: '18bf8d57-939e-4a55-9f54-649fc88c4e69',
            labels: {
              label_id: 'a47ded08-521e-43be-8209-0d5d8c00a788',
              pt: 'Não estou trabalhando no momento',
              // eslint-disable-next-line
              en: "I'm not working at the moment",
              es: 'No estoy trabajando en este momento',
            },
          },
          {
            option_id: 'b9d07498-3d6a-4c01-a28f-e402c3070f49',
            labels: {
              label_id: 'c44a1201-48f1-489e-93dd-9f2884779ac4',
              pt: 'Pesquisa e desenvolvimento',
              en: 'Research and development',
              es: 'Investigación y desarrollo',
            },
          },
          {
            option_id: '5b6904e6-25e9-410a-ae68-fcbd71574e57',
            labels: {
              label_id: 'fd8d9c19-4f1d-481f-883f-b73bd6ee902d',
              pt: 'Contabilidade - Finanças',
              en: 'Accounting - Finance',
              es: 'Contabilidad - Finanzas',
            },
          },
          {
            option_id: '1bb2980c-d8f1-4742-8e4e-de34caacbdeb',
            labels: {
              label_id: '2eb6923e-117a-4345-a422-5e08701cf95e',
              pt: 'Logístico - Transporte',
              en: 'Logistic - Transportation',
              es: 'Logístico - Transporte',
            },
          },
          {
            option_id: 'cf93a18b-cfe9-43d5-85d1-3e79bb6636b6',
            labels: {
              label_id: '6d77b874-bdde-4ad2-b579-519f1b00f046',
              pt: 'Administração',
              en: 'Administration',
              es: 'Administración',
            },
          },
          {
            option_id: '81906649-8d3e-4521-9e34-3f8a2e6c996e',
            labels: {
              label_id: '1e86c879-a602-41a3-be82-7df43bea58db',
              pt: 'Tecnologia da Informação',
              en: 'Information Technology',
              es: 'Tecnología de la información',
            },
          },
          {
            option_id: '2ac219e0-cdf7-478b-b45b-ed674d2866de',
            labels: {
              label_id: '955a3fb0-eb34-4cd3-9ea5-e0da772a463c',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
          {
            option_id: 'de366c38-dcc4-45b1-9cff-ef768a2654d8',
            labels: {
              label_id: '80ea92e2-0d53-49a3-818b-c4810397f9b0',
              pt: 'Gestão de projetos',
              en: 'Project management',
              es: 'Gestión de proyectos',
            },
          },
          {
            option_id: 'e9c91e12-94cb-4a17-89f5-4cf7a2ac6139',
            labels: {
              label_id: '8899eda3-f0cc-40a5-a44a-dd88e04027ad',
              pt: 'Design',
              en: 'Design',
              es: 'Diseño',
            },
          },
          {
            option_id: '40bd8e5c-87de-46c2-9f88-311e1325c77d',
            labels: {
              label_id: '6daf8e64-77e5-4200-9818-1ea34150701d',
              pt: 'Instalação – Manutenção',
              en: 'Installation - Maintenance',
              es: 'Instalación - Mantenimiento',
            },
          },
          {
            option_id: 'a75dcf42-c00c-4086-8b55-a80aff477df7',
            labels: {
              label_id: 'a00e0e8c-5da6-4a90-954c-d0a235f3dcc0',
              pt: 'Controle de qualidade',
              en: 'Quality control',
              es: 'Control de calidad',
            },
          },
          {
            option_id: '0c46b75f-d0e8-401d-9454-d45357969916',
            labels: {
              label_id: 'dccf1d4b-53c2-46d0-9470-2f88dd03c3fd',
              pt: 'Serviço ao cliente',
              en: 'Customer service',
              es: 'Servicio al cliente',
            },
          },
          {
            option_id: '4a31fced-a75d-4bd7-b02b-d6e2168c80d4',
            labels: {
              label_id: '7ade2029-25d5-4c82-b932-6939b4807f26',
              pt: 'Saúde',
              en: 'Health',
              es: 'Salud',
            },
          },
          {
            option_id: 'f1134ca9-a0dd-4f6a-aa63-2af12880716d',
            labels: {
              label_id: '2c1c88cd-67fe-4bc2-a42d-474ec2755e92',
              pt: 'Engenharia',
              en: 'Engineering',
              es: 'Ingeniería',
            },
          },
          {
            option_id: '1a7aa1f3-5b76-454d-95b9-9dca6a7e2dc1',
            labels: {
              label_id: '79b8b1c5-817e-49cf-9b91-f2547db33163',
              pt: 'Construção',
              en: 'Construction',
              es: 'Construcción',
            },
          },
          {
            option_id: 'cbce9c4d-8cc4-4ea7-9856-f4ce00518028',
            labels: {
              label_id: 'bd6d7074-f881-46af-9eb7-66bfa24dc0a3',
              pt: 'Redação',
              en: 'Writing',
              es: 'Redacción',
            },
          },
          {
            option_id: '64f1ef44-a27d-4e38-8fd3-cab5c6b010ad',
            labels: {
              label_id: 'e5659ae1-63cf-4733-86d1-c9ec39ae52b8',
              pt: 'Produção',
              en: 'Production',
              es: 'Producción',
            },
          },
          {
            option_id: '2507ffd5-8e7a-4065-bad7-4f27490d95da',
            labels: {
              label_id: 'b2e677dd-5fae-47c2-83f5-96f28f0fd0e1',
              pt: 'Vendas',
              en: 'Sales',
              es: 'Ventas',
            },
          },
          {
            option_id: 'd8f4ede7-8651-422e-9a51-2996fbf62559',
            labels: {
              label_id: '0d57da08-886e-4aff-b29f-df4475978b07',
              pt: 'Influenciador - Criador de conteúdo',
              en: 'Influencer - Content creator',
              es: 'Influencer - Creador de contenido',
            },
          },
        ],
        required: 1,
        order: 2,
        active: 1,
      },
      {
        question_id: '8f8b591d-b585-47c4-89da-ffb49f85ea82',
        labels: {
          label_id: 'fa376aab-fee7-4df9-9c32-e98a11be8807',
          pt: 'Qual é a renda média mensal em seu domicílio?',
          en: 'What is the average monthly income in your home?',
          es: '¿Cuál es la renta media mensual en su hogar?',
        },
        type: 'select',
        options: [
          {
            option_id: '64583260-fbd1-42ad-8443-2e83d92ac8bc',
            labels: {
              label_id: '69419733-c73d-4995-b700-259060faf537',
              pt: 'Prefiro não responder',
              en: 'I prefer not to answer',
              es: 'Prefiero no responder',
            },
          },
          {
            option_id: 'e92bf014-1fe9-4486-a7f3-1a5d12b1c4d0',
            labels: {
              label_id: '0562e465-d688-497c-abe1-2c682afc3054',
              pt: 'R$ 2.090,01 a R$ 4.180,00',
              en: 'R$ 2,090.01 to R$ 4,180.00',
              es: 'R$ 2.090,01 a R$ 4.180,00',
            },
          },
          {
            option_id: '102a8e89-3468-4825-8a8c-8f3d65cc14c9',
            labels: {
              label_id: '7e03e000-6ffd-4cc8-bad2-9079e52369b5',
              pt: 'R$ 4.180,01 a R$ 10.450,00',
              en: 'R$ 4,180.01 to R$ 10,450.00',
              es: 'R$ 4.180,01 a R$ 10.450,00',
            },
          },
          {
            option_id: '3051053f-188e-43f7-a3c6-8eb32eaf28ab',
            labels: {
              label_id: '37ba3ea0-59c6-4030-a481-6eb2bd481be3',
              pt: 'Até R$ 2.090,00',
              en: 'Up to R$ 2,090.00',
              es: 'Hasta R$ 2.090,00',
            },
          },
          {
            option_id: '9f9d12e6-9bbd-42d8-9588-682ba3980b1b',
            labels: {
              label_id: '80080986-4242-4ac1-9df8-73d3cc89304c',
              pt: 'R$ 10.450,01 a R$ 20.900,00',
              en: 'R$ 10,450.01 to R$ 20,900.00',
              es: 'R$ 10.450,01 a R$ 20.900,00',
            },
          },
          {
            option_id: '2efa7227-7a5d-4e77-9702-d98d2c7bf0d1',
            labels: {
              label_id: 'a02f8b6b-7f0a-4880-8ae4-52f414738960',
              pt: 'R$ 20.900,01 ou mais',
              en: 'R$ 20,900.01 or more',
              es: 'R$ 20.900,01 o más',
            },
          },
        ],
        required: 1,
        order: 3,
        active: 1,
      },
      {
        question_id: 'cbf4fe5a-335f-4b9d-a695-173cb999c8b2',
        labels: {
          label_id: 'aff4f85d-c5d0-4695-a89d-d125084b48f6',
          pt: 'Qual seu estado civil?',
          en: 'What is your marital status?',
          es: '¿Cuál es su estado civil?',
        },
        type: 'select',
        options: [
          {
            option_id: '25f25fcc-57a0-4a84-83f5-57a5460b9ab7',
            labels: {
              label_id: '3047ac4a-dfba-42fa-8977-7b68ad751d3e',
              pt: 'Casado',
              en: 'Married',
              es: 'Casado',
            },
          },
          {
            option_id: '32abbf45-40db-4925-a3a2-cca842332775',
            labels: {
              label_id: '62d6dbbc-e00e-4611-87a1-f2212c2a76b3',
              pt: 'Divorciado',
              en: 'Divorced',
              es: 'Divorciado',
            },
          },
          {
            option_id: 'e0405478-f769-4a17-bebd-6abec9b0dd56',
            labels: {
              label_id: '64c908ca-769c-4535-b379-924dc191af75',
              pt: 'Separado',
              en: 'Separated',
              es: 'Separado',
            },
          },
          {
            option_id: '1e49be54-9abb-470b-a51a-840919328516',
            labels: {
              label_id: '9e299653-4120-469b-a797-5ff122815c2d',
              pt: 'Solteiro',
              en: 'Single',
              es: 'Soltero',
            },
          },
          {
            option_id: '276a7646-6d6c-4e5f-b731-5f3cfb4e59e0',
            labels: {
              label_id: '45f0e882-7c44-4f60-b20c-d3d7ed8d0078',
              pt: 'Viúvo',
              en: 'Widowed',
              es: 'Viudo',
            },
          },
          {
            option_id: '9ea213c8-581a-4e7c-90e2-10b2e2f1233d',
            labels: {
              label_id: '624e6093-c692-4b84-9f89-448a12e86c25',
              pt: 'Morando com parceiro/União estável',
              en: 'Living with partner / Stable union',
              es: 'Viviendo con pareja / Unión estable',
            },
          },
        ],
        required: 1,
        order: 4,
        active: 1,
      },
      {
        question_id: 'f1888d80-c30d-4fd4-a0cd-fe25a877025a',
        labels: {
          label_id: 'ee4eed09-dbf4-474d-9f3f-9c20ca1ebfef',
          pt: 'Você tem filho(s)? Quantos?',
          en: 'Do you have children? How many?',
          es: '¿Tienes hijos? ¿Cuántos?',
        },
        type: 'select',
        options: [
          {
            option_id: '8309d3c0-9674-4270-acd9-6fed9d389786',
            labels: {
              label_id: '25d05674-12d8-4c3d-bdbe-3e1d95c50f96',
              pt: '2',
              en: '2',
              es: '2',
            },
          },
          {
            option_id: 'b8b2c5a1-1f49-495c-ae32-5780b4066bc9',
            labels: {
              label_id: 'c6ab5831-d1c0-4c88-8915-9be7633403e5',
              pt: 'Não tenho',
              // eslint-disable-next-line
              en: "I don't have",
              es: 'No tengo',
            },
          },
          {
            option_id: '35523bb7-694a-416b-8e6c-48499cca64c7',
            labels: {
              label_id: 'aa6723d0-398c-4999-a137-3f5f8a27aae1',
              pt: '3',
              en: '3',
              es: '3',
            },
          },
          {
            option_id: '86e629ae-a919-4619-b166-285afa54d521',
            labels: {
              label_id: 'b35cdc58-777a-4091-af13-9c9f157142b8',
              pt: '4',
              en: '4',
              es: '4',
            },
          },
          {
            option_id: 'b912636f-c6a5-4e51-a143-a7caad898515',
            labels: {
              label_id: 'af874c98-1738-470a-b02b-656130660e30',
              pt: '1',
              en: '1',
              es: '1',
            },
          },
          {
            option_id: '2c1cf2c6-257e-4e12-ade6-b58a3944ddff',
            labels: {
              label_id: 'a478e09d-e059-421d-a2e0-1cab70c217cd',
              pt: '5 ou mais',
              en: '5 or more',
              es: '5 o más',
            },
          },
        ],
        required: 1,
        order: 5,
        active: 1,
      },
      {
        question_id: '4554caaf-b988-42ee-8f16-dae8e200fffe',
        labels: {
          label_id: 'd208e1a4-a99b-4f80-bdce-8b0424d05859',
          pt: 'Se você possue filhos, selecione as faixas de idade dos seus filhos',
          en: 'If you have children, select the age ranges of your children',
          es: 'Si tienes hijos, seleccione los rangos de edad de sus hijos',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '4259e78f-6051-4908-8d00-df5b4101d945',
            labels: {
              label_id: 'b42283ce-1aff-4375-9a12-eee34fbbd95b',
              pt: '15 a 17 anos de idade',
              en: '15 to 17 years old',
              es: '15 a 17 años de edad',
            },
          },
          {
            option_id: '843cd4c4-e41d-4e16-8c53-1fa48e09051c',
            labels: {
              label_id: '65692618-e832-42a0-ab08-4e6c483f0b37',
              pt: '12 a 14 anos de idade',
              en: '12 to 14 years old',
              es: '12 a 14 años de edad',
            },
          },
          {
            option_id: 'e123115d-4527-472d-8d04-37bd9c71c9e3',
            labels: {
              label_id: '4f265c56-05e1-42cc-b60c-617415341bda',
              pt: 'acima de 18',
              en: 'above 18',
              es: 'más de 18',
            },
          },
          {
            option_id: '1f3f8e3e-49d6-4b2a-8380-2d0604ca1d6f',
            labels: {
              label_id: '926811c3-478e-4cca-976d-b678db020b0a',
              pt: '0 a 1 anos de idade',
              en: '0 to 1 years old',
              es: '0 a 1 años de edad',
            },
          },
          {
            option_id: '595d6b6f-2b4e-4949-9a62-9542049f567c',
            labels: {
              label_id: 'fa9124b3-ea33-494d-b745-5c6d54b5b3ce',
              pt: '2 a 3 anos de idade',
              en: '2 to 3 years old',
              es: '2 a 3 años de edad',
            },
          },
          {
            option_id: 'c2f99e0a-b38d-4792-9c2e-c287e7fab5b3',
            labels: {
              label_id: '16f62f68-dd12-4693-845b-3f08b62d1437',
              pt: '4 a 7 anos de idade',
              en: '4 to 7 years old',
              es: '4 a 7 años de edad',
            },
          },
          {
            option_id: '0fd7d260-8ee8-49cf-8ca5-a6c453d2321a',
            labels: {
              label_id: '752c229e-4301-48cf-8ee7-8ef02b9711a7',
              pt: '8 a 11 anos de idade',
              en: '8 to 11 years old',
              es: '8 a 11 años de edad',
            },
          },
        ],
        required: 0,
        order: 6,
        active: 1,
      },
      {
        question_id: '39225861-2da2-448b-a8cb-5199b1de58f6',
        labels: {
          label_id: '7eb60846-c93c-4017-9d55-b56777f1d973',
          pt: 'Com quem você mora?',
          en: 'Who do you live with?',
          es: '¿Con quién vives?',
        },
        type: 'select',
        options: [
          {
            option_id: '02ae4b55-f9a2-4e94-824a-2397b262228d',
            labels: {
              label_id: '805e1178-5bfa-4063-853a-39591bb783d4',
              pt: 'Com meu parceiro(a)',
              en: 'With my partner',
              es: 'Con mi pareja',
            },
          },
          {
            option_id: '5bc79fd2-258b-41b2-92fe-91a1d8934233',
            labels: {
              label_id: 'f5f65ca1-bfc6-45d9-9c12-82b3833cda41',
              pt: 'Com meu(s) amigo(s)',
              en: 'With my friend(s)',
              es: 'Con mi(s) amigo(s)',
            },
          },
          {
            option_id: 'd6e3522b-9aaf-45f5-a742-cbf2e1955d32',
            labels: {
              label_id: 'dec114db-354a-4d46-a157-ac82db5bc075',
              pt: 'Com minha família (parceiro(a) e/ou filho(s))',
              en: 'With my family (partner and/or children)',
              es: 'Con mi familia (pareja y/o hijos)',
            },
          },
          {
            option_id: '311b1e6f-f452-4547-a450-4eaf06039432',
            labels: {
              label_id: 'f9616e10-3a00-4092-8e5b-b723748e3609',
              pt: 'Com meus pais e/ou outro familiar.',
              en: 'With my parents and/or another relative.',
              es: 'Con mis padres y/o otro familiar.',
            },
          },
          {
            option_id: 'a0800a0d-92a0-44bc-821a-6c960665c0a1',
            labels: {
              label_id: 'f346b2c9-6e3b-4a5d-8186-589bc5401c2f',
              pt: 'Sozinho',
              en: 'Alone',
              es: 'Solo',
            },
          },
        ],
        required: 1,
        order: 7,
        active: 1,
      },
      {
        question_id: '9361890a-ab5d-4c8e-84a7-bc67a8c8b0e8',
        labels: {
          label_id: '87b883b6-eef1-4e40-85b0-2ca8cb03e2dd',
          pt: 'Qual tipo de imóvel você mora?',
          en: 'What type of property do you live in?',
          es: '¿Qué tipo de propiedad vives?',
        },
        type: 'select',
        options: [
          {
            option_id: '3991abda-3128-4efd-a24a-a20e215fad91',
            labels: {
              label_id: 'f45952aa-b4c9-4fbf-a531-e3e1b244313e',
              pt: 'Casa',
              en: 'House',
              es: 'Casa',
            },
          },
          {
            option_id: '7b7628fc-4f52-406e-95c2-b574804f9d42',
            labels: {
              label_id: 'eddec52c-097c-40ea-b72e-d6ea3011d4a4',
              pt: 'Apartamento',
              en: 'Apartment',
              es: 'Apartamento',
            },
          },
          {
            option_id: '3680b81a-9daa-446a-845e-f73f26482420',
            labels: {
              label_id: 'fd167ce9-facf-471b-b846-07ee5224d097',
              pt: 'Flat/Studio',
              en: 'Studio',
              es: 'Estudio',
            },
          },
          {
            option_id: '71c8c6b0-8264-4525-8dc2-9871c4bebf55',
            labels: {
              label_id: '922ae5b1-cc2b-4806-86be-bbfa3519b607',
              pt: 'Casa em condomínio fechado',
              en: 'House in a gated community',
              es: 'Casa en condominio cerrado',
            },
          },
        ],
        required: 1,
        order: 8,
        active: 1,
      },
      {
        question_id: '10d09fb9-246d-4859-a237-dc5037bc13ce',
        labels: {
          label_id: '2117fd40-a517-47ff-ab50-4b324a3204ea',
          pt: 'Você tem carteira de habilitação?',
          //  eslint-disable-next-line
          en: "Do you have a driver's license?",
          es: '¿Tiene licencia de conducir?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '94e978bb-9eb8-4713-8c1a-82136ab9acf0',
            labels: {
              label_id: '35346eac-b631-44e4-aa6f-0276e3db6837',
              pt: 'E (Veículos com unidade acoplada acima de 6 ton.)',
              en: 'E (Vehicles with a trailer above 6 tons.)',
              es: 'E (Vehículos con remolque superior a 6 toneladas)',
            },
          },
          {
            option_id: '1306bab1-6865-4663-aeed-8f67cb92a850',
            labels: {
              label_id: 'a53e9006-9e83-48ac-b67c-c3d120814175',
              pt: 'D (Veículos com + de 8 passageiros)',
              en: 'D (Vehicles with + 8 passengers)',
              es: 'D (Vehículos con + de 8 pasajeros)',
            },
          },
          {
            option_id: '67a2f636-7ae5-4764-a86c-33ccace0cd12',
            labels: {
              label_id: 'c4dcec0d-f8c8-4414-abf6-0f1b8d488bec',
              pt: 'C (Veículos de carga acima de 3,5 ton.)',
              en: 'C (Vehicles with a load above 3.5 tons.)',
              es: 'C (Vehículos con carga superior a 3,5 toneladas)',
            },
          },
          {
            option_id: 'e1576b22-1c36-4c57-af0c-bdb8c8f05262',
            labels: {
              label_id: '1cd5acc1-0593-4ad7-a7e8-e11b7cb519ae',
              pt: 'A (Motos e Triciclos)',
              en: 'A (Motorcycles and Tricycles)',
              es: 'A (Motocicletas y Triciclos)',
            },
          },
          {
            option_id: '4e93d017-8651-4fbe-aec8-54c07b8b942f',
            labels: {
              label_id: '110a9b8b-17c2-4c22-9e95-4764db268201',
              pt: 'B (Carros de passeio)',
              en: 'B (Passenger cars)',
              es: 'B (Automóviles de pasajeros)',
            },
          },
        ],
        required: 0,
        order: 9,
        active: 1,
      },
      {
        question_id: '4c5888e8-3bbc-440e-850d-b0aabb272f40',
        labels: {
          label_id: 'ee62dc49-24db-4b8e-9c61-e196f8eeb243',
          pt: 'Qual é o seu meio de transporte principal?',
          en: 'What is your main means of transport?',
          es: '¿Cuál es su medio de transporte principal?',
        },
        type: 'select',
        options: [
          {
            option_id: '880d33e5-5e7f-426d-a444-9e3d9762782b',
            labels: {
              label_id: 'fa219d7d-d2af-45bf-8321-4673a74c29df',
              pt: 'Bicicleta/Patinete',
              en: 'Bicycle/Scooter',
              es: 'Bicicleta/Patinete',
            },
          },
          {
            option_id: 'ed4b8b12-8e5b-4d46-a22b-510773c97aa6',
            labels: {
              label_id: 'fac59735-4142-4729-b5b2-840958a6d96b',
              pt: 'Veículo alugado (moto ou carro)',
              en: 'Rented vehicle (motorcycle or car)',
              es: 'Vehículo alquilado (motocicleta o automóvil)',
            },
          },
          {
            option_id: '71d4cad9-50ff-4176-a79e-8541b48e4fa1',
            labels: {
              label_id: '0acf944e-6998-4ca1-bef2-7027d15a5e41',
              pt: 'Veículo próprio (moto ou carro)',
              en: 'Own vehicle (motorcycle or car)',
              es: 'Vehículo propio (motocicleta o automóvil)',
            },
          },
          {
            option_id: 'dda3682e-7029-461a-8194-225610d982bd',
            labels: {
              label_id: '3ca781e9-9960-4660-aeac-7bfb494cb082',
              pt: 'Transporte público (Ônibus, metrô, trem e etc)',
              en: 'Public transport (bus, subway, train, etc.)',
              es: 'Transporte público (autobús, metro, tren, etc.)',
            },
          },
          {
            option_id: '49037e55-4056-4479-97b1-5268327d9b66',
            labels: {
              label_id: 'a1ace586-39a2-4ffc-924c-02f9dc00a429',
              pt: 'Aplicativo de transporte',
              en: 'Transport application',
              es: 'Aplicación de transporte',
            },
          },
        ],
        required: 1,
        order: 10,
        active: 1,
      },
      {
        question_id: '61a836ee-ab8b-4824-ad8a-813a74113d35',
        labels: {
          label_id: 'd4e973d8-f3af-4ee2-afa6-93dd8f29bf1e',
          pt: 'Você tem algum pet, se sim, qual tipo?',
          en: 'Do you have any pet, if so, what type?',
          es: '¿Tiene alguna mascota, si es así, qué tipo?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: 'f46192aa-638d-4e8f-99b4-a1323e6c65eb',
            labels: {
              label_id: '1105b1b3-06e7-45a9-be2b-2d11aba52fca',
              pt: 'Peixes',
              en: 'Fish',
              es: 'Peces',
            },
          },
          {
            option_id: '1ae5fc94-dd15-4a37-9db8-9f32ee2ae32d',
            labels: {
              label_id: '35eb38dc-b2f5-46aa-bd60-5e01f9ca2072',
              pt: 'Gato',
              en: 'Cat',
              es: 'Gato',
            },
          },
          {
            option_id: '981832df-5b59-421b-932a-416459ff7c39',
            labels: {
              label_id: '4f013f63-a136-4a7b-ad4e-bce16b82f26d',
              pt: 'Exóticos',
              en: 'Exotic',
              es: 'Exóticos',
            },
          },
          {
            option_id: 'd489fdd6-c598-4f5f-a9dd-d54a22ccc2ee',
            labels: {
              label_id: 'f6e44ca9-d3f1-4c3e-866e-ed550f123d15',
              pt: 'Outro',
              en: 'Other',
              es: 'Otro',
            },
          },
          {
            option_id: '13b62a4b-6dcb-4df0-95c7-0447d4ad8656',
            labels: {
              label_id: '24c6998c-b0c0-4e1b-bda7-7917e05895f0',
              pt: 'Aves',
              en: 'Birds',
              es: 'Aves',
            },
          },
          {
            option_id: '754cf2be-90e4-4322-a1f8-3924392f7037',
            labels: {
              label_id: '950b14e4-b25a-4083-b2d3-523291b4572f',
              pt: 'Cachorro',
              en: 'Dog',
              es: 'Perro',
            },
          },
          {
            option_id: '9aec5171-71b0-453d-8840-b2ff3ad8c299',
            labels: {
              label_id: '3dbad28c-4251-4a32-bc26-ac57465768a8',
              pt: 'Roadores',
              en: 'Rodents',
              es: 'Roedores',
            },
          },
        ],
        required: 0,
        order: 11,
        active: 1,
      },
      {
        question_id: '4154b44f-41d0-4576-b3a7-051792231fa3',
        labels: {
          label_id: '40c9b750-9842-4e08-9e70-7ebab4f55285',
          pt: 'Você tem alguma restrição alimentar?',
          en: 'Do you have any dietary restrictions?',
          es: '¿Tiene alguna restricción alimentaria?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '741a46cd-627d-4f5d-810c-a5b30e96063b',
            labels: {
              label_id: '2e7a1083-4075-4ccb-bc1f-44b1957a8a92',
              pt: 'Glúten',
              en: 'Gluten',
              es: 'Gluten',
            },
          },
          {
            option_id: 'ce09f8e8-aa2e-457f-9945-b8dc9314208b',
            labels: {
              label_id: '510786d0-411a-4776-82c3-bad033c36bee',
              pt: 'Diabetes',
              en: 'Diabetes',
              es: 'Diabetes',
            },
          },
          {
            option_id: 'd7e805c4-3573-4369-a732-5519603aa291',
            labels: {
              label_id: '9fb2e8f7-625e-4b64-b872-8cce5b8d5623',
              pt: 'Lactose',
              en: 'Lactose',
              es: 'Lactosa',
            },
          },
          {
            option_id: 'aea6b93a-52a7-4bc2-af2f-2eba23b7b686',
            labels: {
              label_id: '3455f492-9faf-45d5-a0f4-7f35a5cc9c2a',
              pt: 'Amendoim',
              en: 'Peanut',
              es: 'Maní',
            },
          },
          {
            option_id: 'd309c363-cfc0-46f8-b135-3349e5c5914e',
            labels: {
              label_id: '49fe09e9-f13f-4a3e-84fc-ce764b4df38f',
              pt: 'Crustáceos',
              en: 'Crustaceans',
              es: 'Crustáceos',
            },
          },
        ],
        required: 0,
        order: 12,
        active: 1,
      },
      {
        question_id: 'a12a469f-7903-46ec-9685-70d36346687b',
        labels: {
          label_id: '949d373b-e8d3-4f3e-b5b1-5b2540461be4',
          pt: 'Você toma algum medicamento de uso contínuo? Se sim, para o quê?',
          en: 'Do you take any continuous medication? If so, for what?',
          es: '¿Toma algún medicamento de uso continuo? Si es así, para qué?',
        },
        type: 'checkbox',
        options: [
          {
            option_id: '1cd2e8e1-8813-405a-a6a7-a14646b86931',
            labels: {
              label_id: '16db3f88-269f-4a9b-8299-3fb44ad2d375',
              pt: 'Artrite ou doenças reumáticas',
              en: 'Arthritis or rheumatic diseases',
              es: 'Artritis o enfermedades reumáticas',
            },
          },
          {
            option_id: '9766d9a4-4e0f-4154-a0ba-31ca04c9c9c0',
            labels: {
              label_id: '32d2beba-8de0-46a3-903a-39389ba63663',
              pt: 'Doença do coração',
              en: 'Heart disease',
              es: 'Enfermedad del corazón',
            },
          },
          {
            option_id: '34301d37-f230-409e-956b-02a1b6d59970',
            labels: {
              label_id: '42719290-86be-411a-9e9c-87aa7ab1d9ca',
              pt: 'LER (Lesões por Esforços Repetitivos)',
              en: 'RSI (Repetitive Strain Injuries)',
              es: 'LER (Lesiones por Esfuerzos Repetitivos)',
            },
          },
          {
            option_id: 'ccbd17e6-6602-4667-98b1-216739d9f7fe',
            labels: {
              label_id: '83ca16cf-0a09-4578-96c4-5a995b740f33',
              pt: 'Cirrose',
              en: 'Cirrhosis',
              es: 'Cirrosis',
            },
          },
          {
            option_id: '41f4199d-37cf-426e-947b-88c4612add4c',
            labels: {
              label_id: 'a9bb36a0-7b0b-44d9-a17a-e760019a0b61',
              pt: 'Outros',
              en: 'Others',
              es: 'Otros',
            },
          },
          {
            option_id: 'cff222e4-f5cd-4759-94b8-44a6ffee5623',
            labels: {
              label_id: '31b14261-b6cb-4ac4-8f62-1e6876595b1a',
              pt: 'Doença renal crônica',
              en: 'Chronic kidney disease',
              es: 'Enfermedad renal crónica',
            },
          },
          {
            option_id: '6c6b376a-4c1b-4606-b90f-aba8345ceccf',
            labels: {
              label_id: '561aff82-3508-4f25-9720-489a76e2a3ae',
              pt: 'TDAH',
              en: 'ADHD',
              es: 'TDAH',
            },
          },
          {
            option_id: '2fdaeff2-2a5a-431a-a302-790d6558718b',
            labels: {
              label_id: 'e389fa4d-32c4-4137-a486-d3fe3bda053c',
              pt: 'Diabetes',
              en: 'Diabetes',
              es: 'Diabetes',
            },
          },
          {
            option_id: '9ac31342-2a87-42b7-95c7-2f9850991df5',
            labels: {
              label_id: '3a5293e6-d957-413d-9d42-78d826313538',
              pt: 'Hipertensão arterial',
              en: 'High blood pressure',
              es: 'Presión arterial alta',
            },
          },
          {
            option_id: '401e0071-2046-4841-bfe2-75586a3000d6',
            labels: {
              label_id: '4f66a527-2dd7-42eb-bae5-50b93d6132fa',
              pt: 'Depressão',
              en: 'Depression',
              es: 'Depresión',
            },
          },
          {
            option_id: 'ce4d5a1c-8cd9-4ba2-adb8-9539e016497d',
            labels: {
              label_id: '52187956-2d47-4641-b22f-f7338e184af8',
              pt: 'Complicações respiratórias (asma| rinite)',
              en: 'Respiratory complications (asthma | rhinitis)',
              es: 'Complicaciones respiratorias (asma | rinitis)',
            },
          },
          {
            option_id: '51caef38-6095-480b-b553-9c8c5469db87',
            labels: {
              label_id: 'c4902e47-817f-4922-b32c-f5014a6871f0',
              pt: 'Colesterol alto',
              en: 'High cholesterol',
              es: 'Colesterol alto',
            },
          },
          {
            option_id: 'fb63adc9-f1b1-4a3b-9866-fd877ae8774a',
            labels: {
              label_id: 'd9f12274-7f84-4cb5-b563-cf32ff3290fb',
              pt: 'Dores crônicas',
              en: 'Chronic pain',
              es: 'Dolor crónico',
            },
          },
        ],
        required: 0,
        order: 13,
        active: 1,
      },
    ],
    icon: 'person-simple',
    order: 1,
  },
] as QuestionGroupedInterface[]
